module.exports = __webpack_public_path__ + "media/preview/meetup@2x-51142065.png";